/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The ServerInfoDTO model module.
* @module model/ServerInfoDTO
* @version 0.7.15
*/
export default class ServerInfoDTO {
    /**
    * Constructs a new <code>ServerInfoDTO</code>.
    * @alias module:model/ServerInfoDTO
    * @class
    * @param restVersion {String} The catapult-rest component version.
    * @param sdkVersion {String} The catapult-sdk component version.
    */

    constructor(restVersion, sdkVersion) {
        

        
        

        this['restVersion'] = restVersion;this['sdkVersion'] = sdkVersion;

        
    }

    /**
    * Constructs a <code>ServerInfoDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ServerInfoDTO} obj Optional instance to populate.
    * @return {module:model/ServerInfoDTO} The populated <code>ServerInfoDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ServerInfoDTO();

            
            
            

            if (data.hasOwnProperty('restVersion')) {
                obj['restVersion'] = ApiClient.convertToType(data['restVersion'], 'String');
            }
            if (data.hasOwnProperty('sdkVersion')) {
                obj['sdkVersion'] = ApiClient.convertToType(data['sdkVersion'], 'String');
            }
        }
        return obj;
    }

    /**
    * The catapult-rest component version.
    * @member {String} restVersion
    */
    restVersion = undefined;
    /**
    * The catapult-sdk component version.
    * @member {String} sdkVersion
    */
    sdkVersion = undefined;








}


